/**
 * 화면 아래쪽에 잠깐 떴다가 사라지는 알림 (2026-10-13).
 * 연주목록에 담아도 아무 반응이 없어 됐는지 알 수 없었음 → 담기 결과를 보여 준다.
 */
let el: HTMLDivElement | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;

export const showToast = (text: string, ms = 2200) => {
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    Object.assign(el.style, {
      position: 'fixed', left: '50%', top: '76px', transform: 'translate(-50%, -8px)',
      maxWidth: 'calc(100% - 32px)', boxSizing: 'border-box', padding: '12px 18px',
      borderRadius: '10px', background: 'rgba(20, 22, 28, 0.92)', color: '#fff',
      fontSize: '14px', lineHeight: '1.5', textAlign: 'center', wordBreak: 'keep-all',
      boxShadow: '0 4px 16px rgba(0,0,0,0.3)', zIndex: '1000000', pointerEvents: 'none',
      opacity: '0', transition: 'opacity .25s ease, transform .25s ease',
    } as CSSStyleDeclaration);
    document.body.appendChild(el);
  }
  el.textContent = text;
  // 다음 그리기에서 나타나게 (처음 붙인 직후 바로 바꾸면 애니메이션이 안 됨)
  requestAnimationFrame(() => {
    if (!el) return;
    el.style.opacity = '1';
    el.style.transform = 'translate(-50%, 0)';
  });
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translate(-50%, -8px)';
  }, ms);
};
